<template>
  <div>
    <div style="margin-bottom: 10px;">
      <SwiperList :swiperList="swiperList"></SwiperList>
    </div>
    <div style="padding: 0px 10px 20px 10px" class="w-inner">
      <div class="b-d-b c-hui" style="font-size: 14px;padding-right: 2px;padding-bottom: 2px;margin-bottom: 10px;" flex="main:right"><span @click="backList">返回列表页<span style="color: #999;">》</span></span></div>
      <div  class="content-flg">
        <div style="font-size: 18px;text-align: center;font-weight: 900;padding-bottom: 20px;">{{model.operwcontitle}}</div>
        <!-- <div v-if="isShow()" style="width: 100%;text-align: center;">日期: {{model.createtime | shortDate }}</div> -->
        <div v-show="isShow()" style="display: flex;align-items:center;justify-content: center;">
              <div style="text-align: center;margin-right: 4px;">日期: {{model.createtime | shortDate }}</div>
              <div style="text-align: center;">阅读数: {{model.click == 0? 1 : +model.click + 1}}</div>
            </div>
        <div v-html="model.operwconcontents" class="operwconcontents">
        </div>
        <div style="display:flex" v-if="model.appends">
              <div v-if="model.appends.length>0">附件信息：</div>
              <div v-if="model.appends.length > 0">
                  <div v-for="i in model.appends" :key="i.id">
                    <div @click="downFile(i.appendurl)" style="color:#2f74ff;cursor: pointer;">{{i.appendfilename}}</div>
                  </div>
                
              </div>
            </div>
      </div>
      <div class="a-c c-hui" style="font-size: 14px; padding-top: 50px">
        <div style="width: 150px;margin: auto;position: relative" class="b-d-b">
          <span style="position: absolute;left: 40px;top: -10px;background: #fff;" class="p-h" @click="backList">返回列表页</span>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import SwiperList from './SwiperList.vue'
  import common from '../../mixin/common'
  import utils from '../../assets/js/utils.js'
  export default {
    mixins: [common],
    data () {
      return {
        model: {},
        swiperList: []
      }
    },
    created () {
      document.documentElement.scrollTop = 0
      this.$store.dispatch('getOperwconList', {id: this.$route.query.id}).then(data => {
        this.model = data[0]
        this.model.operwconcontents = this.model.operwconcontents.replace(/upload/g, this.picAddr + 'upload')
      })
      this.findSwiperList()
      this.$store.dispatch('updateOperWconClick', {id: this.$route.query.id})
    },
    filters: {
      shortDate: function (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd')
      }
    },
    methods: {
      isShow () {
        return +this.$route.query.mtid === 114
      },
      backList () {
        this.$store.commit('setFirstActiveTab', this.firstActiveTab)
        this.$store.commit('setSecondActiveTab', this.secondActiveTab)
        this.$store.commit('changId', this.$route.query.leftId ? this.$route.query.leftId : '')
        this.$router.push({name: 'product', params: {operMtId: this.$route.query.mtid}})
      },
      findSwiperList () {
        this.$store.dispatch('findSwiperList', {operadmtid: this.$route.query.mtid}).then(data => {
          if (data) {
            this.swiperList = data.appends
          }
        })
      }
    },
    watch: {
      $route () {
        this.$store.dispatch('updateOperWconClick', {id: this.$route.query.id})
      }
    },
    components: {SwiperList},
    computed: mapState({
      secondActiveTab: state => state.secondActiveTab,
      firstActiveTab: state => state.firstActiveTab,
      mtid: state => state.id,
      picAddr: state => state.picAddr
    })
  }
</script>

<style scoped>
  span {
    cursor: pointer;
  }
  .dot {
    margin-top: -16px;
  }
</style>



// WEBPACK FOOTER //
// OperWconDetail.vue?7e8745d0